import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

interface CTASectionProps {
  title?: string;
  subtitle?: string;
  buttonLabel?: string;
  buttonLink?: string;
  variant?: 'primary' | 'petrol';
  isExternal?: boolean;
}

const CTASection = ({
  title = 'Prête à sublimer votre peau ?',
  subtitle = 'Prenez rendez-vous en ligne et offrez-vous un moment de bien-être chez Body by CC.',
  buttonLabel = 'Prendre rendez-vous',
  buttonLink = '/contact',
  variant = 'petrol',
  isExternal = false,
}: CTASectionProps) => {
  const isPetrol = variant === 'petrol';

  const buttonClasses = `inline-flex items-center gap-2 px-7 py-3 rounded-full font-heading font-medium text-base md:text-lg transition-colors ${
    isPetrol
      ? 'bg-primary text-primary-foreground hover:bg-primary/90'
      : 'bg-white text-primary hover:bg-white/90'
  }`;

  return (
    <section className="px-6 lg:px-8 pt-4 pb-10 md:pt-6 md:pb-14 bg-background">
      <div className="max-w-4xl mx-auto">
        <div
          className={`relative rounded-2xl px-8 py-12 md:px-14 md:py-16 ${
            isPetrol ? 'bg-petrol border border-petrol-foreground/10' : 'bg-primary border border-primary-foreground/15'
          }`}
        >
          {/* Corner accents */}
          <div className={`absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 rounded-tl-2xl ${isPetrol ? 'border-accent' : 'border-white/60'}`} />
          <div className={`absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 rounded-tr-2xl ${isPetrol ? 'border-accent' : 'border-white/60'}`} />
          <div className={`absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 rounded-bl-2xl ${isPetrol ? 'border-accent' : 'border-white/60'}`} />
          <div className={`absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 rounded-br-2xl ${isPetrol ? 'border-accent' : 'border-white/60'}`} />

          <div className="text-center">
            <h2 className={`font-heading text-2xl md:text-3xl font-bold ${isPetrol ? 'text-petrol-foreground' : 'text-primary-foreground'}`}>
              {title}
            </h2>
            <p className={`mt-4 text-sm max-w-lg mx-auto leading-relaxed font-body ${isPetrol ? 'text-petrol-foreground/60' : 'text-primary-foreground/70'}`}>
              {subtitle}
            </p>
            <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
              {isExternal ? (
                <a
                  href={buttonLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={buttonClasses}
                >
                  {buttonLabel} <ArrowRight size={15} />
                </a>
              ) : (
                <Link
                  to={buttonLink}
                  onClick={() => window.scrollTo(0, 0)}
                  className={buttonClasses}
                >
                  {buttonLabel} <ArrowRight size={15} />
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;